import React, {useState} from 'react';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import {IconButton} from '@material-ui/core';
import PageLoader from '../../../../components/PageLoader';
import Done from '@material-ui/icons/Done';
import Clear from '@material-ui/icons/Clear';
import {v4 as uuidv4} from 'uuid';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  customTable: {
    backgroundColor: '#32046926',
  },
}));
const FieldTable = ({
  selectedRows,
  setSelectedRows,
  values,
  handleChange,
  touched,
  errors,
  inputFieldValues,
  setInputFieldValues,
  setFieldValue,
  setDeleteEnableId,
  deleteEnableId,
  setEventClientData,
  eventClientData,
}) => {
  const [loader, setLoader] = useState(false);
  const classes = useStyles();
  const reorderItems = (startIndex, endIndex) => {
    const arr = [...eventClientData];
    const [removed] = arr.splice(startIndex, 1);
    arr.splice(endIndex, 0, removed);
    setEventClientData(arr);
  };

  const onDragEnd = (result) => {
    const {source, destination} = result;
    if (!destination) {
      return;
    }
    reorderItems(source.index, destination.index);
  };

  const handleDelete = (rowData, key) => {
    const arr = [...eventClientData];

    arr.forEach((ele) => {
      delete ele.deleteState;
    });
    arr.splice(key, 1, {...arr[key], deleteState: true});
    setEventClientData(arr);
  };

  const handleConfirmDelete = (rowData, key) => {
    setLoader(true);
    setTimeout(() => {
      const arr = [...eventClientData].filter((r) => r.fieldCode !== rowData.fieldCode);
      setEventClientData(arr);
      setLoader(false);
    }, 1000);
  };

  const handleCancel = (rowData, key) => {
    const arr = [...eventClientData];
    arr.forEach((ele) => {
      delete ele.deleteState;
    });
    setEventClientData(arr);
  };

  const columns = [
    {
      title: 'Actions',
    },
    {
      title: 'Seq No',
    },
    {
      title: 'Event Tactic Code',
    },
    {
      title: 'Event Tactic Description',
    },
    {
      title: 'Mode',
    },
    {
      title: 'Continue/Processing',
    },
  ];
  return (
    <>
      <div className={`mui-custom-table-container ${classes.customTable}`}>
        <DragDropContext onDragEnd={onDragEnd}>
          <table>
            <thead>
              <tr>
                {columns.map(
                  ({title, hidden = false}) => !hidden && <th key={title}>{title}</th>,
                )}
              </tr>
            </thead>
            <Droppable droppableId="droppabe-list">
              {(provided) => (
                <tbody ref={provided.innerRef}>
                  {eventClientData?.length > 0 ? (
                    eventClientData.map((rowData, key) => {
                      return (
                        <Draggable draggableId={`draggable-${key}`} key={uuidv4()} index={key}>
                          {(provided) =>
                            rowData.deleteState ? (
                              <tr
                                className="delete-row"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <td>
                                  <div>
                                    <IconButton
                                      onClick={(e) => {
                                        handleConfirmDelete(rowData, key);
                                      }}
                                    >
                                      <Done />
                                    </IconButton>
                                    <IconButton
                                      onClick={(e) => {
                                        handleCancel(rowData, key);
                                      }}
                                    >
                                      <Clear />
                                    </IconButton>
                                  </div>
                                </td>
                                <td
                                  colSpan={columns.length - 1}
                                  style={{textAlign: 'left', fontWeight: 'bold'}}
                                >
                                  Are you sure you want to delete
                                </td>
                              </tr>
                            ) : (
                              <tr
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <td className="recFormat-center">
                                  <IconButton
                                    onClick={(e) => {
                                      handleDelete(rowData, key);
                                    }}
                                  >
                                    <DeleteOutlined />
                                  </IconButton>
                                </td>

                                <td>{key + 1}</td>
                                <td>{rowData.code}</td>
                                <td>{rowData.description}</td>
                                <td>{rowData.mode}</td>

                                <td>
                                  {rowData.seqNo(
                                    values,
                                    handleChange,
                                    touched,
                                    errors,
                                    inputFieldValues,
                                    setInputFieldValues,
                                    setFieldValue,
                                  )}
                                </td>
                              </tr>
                            )
                          }
                        </Draggable>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan={columns.length}
                      >
                        No records to display
                      </td>
                    </tr>
                  )}
                  {provided.placeholder}
                  {loader && <PageLoader />}
                </tbody>
              )}
            </Droppable>
          </table>
        </DragDropContext>
      </div>
    </>
  );
};

export default FieldTable;
